<template>
    <el-dialog
        title="作品审核"
        :visible.sync="dialogFormVisible"
        width="1000px" :close-on-click-modal="false">
        <!--<div class="examine">
            <h2>报名信息</h2>
            <div class="examineList">
                <p>报名时间 :</p>
                <p>{{ sign.createTime }}</p>
            </div>
            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称 :</p>
                    <p>{{ sign.name }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名 :</p>
                    <p>{{ sign.name }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:</p>
                    <p>{{ sign.tel }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p>参赛主体 :</p>
                    <p>{{ sign.signTypeCn }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p>主体名称 :</p>
                    <p>{{ sign.teamName }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p>团队成员 :</p>
                    <p>{{ sign.teamMember }}</p>
                </div>
            </div>
        </div>-->
        <div class="examine">
            <h2>作品信息</h2>
            <div class="examineList">
                <p style="white-space:nowrap">昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称 :</p>
                <p>{{ sign.name }}</p>
            </div>
            <div class="examineList">
                <p>作品类别 :</p>
                <p>{{ info.typeName }}</p>
            </div>
            <div class="examineList">
                <p>作品封面 :</p>
                <img :src="info.coverUrl" alt="">
            </div>

            <div class="examineList">
                <p>作品名称 :</p>
                <p>{{ info.name }}</p>
            </div>

            <div class="examineList_html">
                <p>作品简介 :</p>
                <p v-html="info.summary" class="vHtml"></p>
            </div>
            <!--<div class="examineList">
                <p>参赛作品 :</p>
                <p style="color: #1890FF;cursor: pointer;" @click="downloadFile(info.worksUrl)">{{ info.worksName }}</p>
            </div>-->
            <div class="examineList_html">
                <p>作品说明 :</p>
                <p v-html="info.description" class="vHtml"></p>
            </div>
            <!--<div class="examineList">
                <p style="white-space:nowrap">附&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件 :</p>
                <p style="color: #1890FF;cursor: pointer;" @click="downloadFile(info.videoUrl)">{{ info.videoName }}</p>
            </div>-->
            <div class="examineList">
                <p style="white-space:nowrap">参赛作品 :</p>
                <!--<p style="color: #1890FF;cursor: pointer;"
                   v-if="worksFileList.length>0"
                   v-for="(item,index) in worksFileList"
                   :key="index"
                   @click="viewInfo(item.url,item.name)">
                    {{ item.name }}
                </p>-->
                <div>
                    <el-popconfirm
                        v-if="worksFileList.length>0"
                        v-for="(item,index) in worksFileList"
                        :key="index"
                        @confirm="viewInfo(item.url,item.name)"
                        @cancel="downloadFile(item.url,item.name)"
                        confirm-button-text='预览'
                        cancel-button-text='下载'
                        icon="el-icon-info"
                        title="请选择操作"
                        width="250"
                    >
                        <el-button slot="reference" style="margin-right:10px;margin-bottom:10px">{{ item.name }}</el-button>
                    </el-popconfirm>
                </div>
            </div>
        </div>
        <div :class="tableData.length != 0?'examineList_mess':'examineList2'">
            <p>评委评分记录:</p>
            <el-table
                v-if="tableData.length != 0"
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    prop="userName"
                    label="评委名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="score"
                    label="评分"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="remark"
                    label="意见">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="评分时间">
                </el-table-column>
            </el-table>
            <p v-else>未评分</p>
        </div>
        <div class="audit">
            <h3>审核</h3>
            <div class="auditContent">
                <el-radio-group v-model="auditForm.status">
                    <el-radio label="PASS">通过</el-radio>
                    <el-radio label="REJECT">驳回</el-radio>
                </el-radio-group>
                <div class="cause" v-if="auditForm.status === 'REJECT'">
                    <div class="causeTitle">驳回原因：</div>
                    <div class="causeContent" style="width: 100%">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 5 }"
                            placeholder="请输入驳回原因"
                            v-model="auditForm.remark"
                        >
                        </el-input>
                    </div>
                </div>
                <div class="auditEnter">
                    <el-button type="primary" @click="auditSubmit(info.uuid)">确定</el-button>
                </div>
            </div>
        </div>
        <!--<el-dialog
            title="图片预览"
            :close-on-click-modal="false"
            :append-to-body="true"
            :visible.sync="visibleImg">
            <div class="modal-content">
                <el-row v-if="isShowImgUpload" style="padding-left:100px;padding-right:100px;">
                    <el-col :span="4" style="color:white">1</el-col>
                    <el-col :span="16">
                        <div style="position:relative;background-color: #f0f3fa;">
                            <img
                                :src="localUrl"
                                :preview-src-list="[localUrl]"
                                style="width:100%;height:100%;"
                                fit="scale-down"
                            />
                        </div>
                    </el-col>
                    <el-col :span="4" style="color:white">1</el-col>
                </el-row>
            </div>
        </el-dialog>
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>-->
        <view-file-dialog ref="viewFileDialog" ></view-file-dialog>
    </el-dialog>
</template>

<script>
import viewFileDialog from './viewFileDialog'
import threeD from "../../components/threeD/index"
import { getWorksDetail,saveLeaderExamine,getWorksScoreInfo } from '../../utils/interface';
export default {
    name: "leaderExamineDialog",
    data() {
        return{
            type:"",
            dialogFormVisible: false,
            auditForm: {
                uuid:'',
                status:'',
                remark:'',
            },
            info:{},
            sign:{},
            tableData:[],
            worksFileList:[],
            // 3D预览
            fileListNew: [],
            innerVisible: false,
            // 图片预览
            isShowImgUpload:false,
            localUrl:"",
            visibleImg:false,
            orderRecordList:[],
        }
    },
    components:{
        threeD,
        viewFileDialog
    },
    methods: {
        init(uuid) {
            this.auditForm = {
                uuid:'',
                status:'',
                remark:'',
            },
            this.auditForm.uuid = uuid;
            this.dialogFormVisible = true;
            getWorksDetail(uuid).then((res)=>{
                this.info = res.info;
                this.sign = res.sign;
                this.worksFileList = res.info.worksFileList;
            });
            getWorksScoreInfo({worksUuid:uuid}).then((res)=>{
                this.tableData = res.data;
            });
        },
        auditSubmit(){
            if(this.auditForm.status === ''){
                this.$message.warning('请选择审核结果！');
            } else if(this.auditForm.status === 'REJECT' && this.auditForm.remark === ''){
                this.$message.warning('请输入驳回原因！');
            } else {
                let params = {
                    worksUuid:this.auditForm.uuid,
                    status:this.auditForm.status,
                    remark:this.auditForm.remark
                };
                saveLeaderExamine(params).then((res)=>{
                    if(res.success){
                        this.$message.success("审核成功");
                        this.dialogFormVisible = false;
                        this.$emit("submit");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            }
        },
        downloadFile(fileUrl,fileName){
            this.$refs.viewFileDialog.init("download", fileName , fileUrl);
            /*let a = document.createElement('a');
            a.href = fileUrl;
            a.download = fileName;
            a.click();*/
        },
        viewInfo(fileUrl){
            let fileType = fileUrl.substr(fileUrl.lastIndexOf('.')+1).toUpperCase();
            this.$refs.viewFileDialog.init("view", fileType, fileUrl);
        },
        closeDlog(index){
            this.innerVisible = index;
        },
        showImg (url) {
            this.visibleImg = true;
            this.localUrl = url;
            this.isShowImgUpload = true;//呈现本地预览组件
        },
        countVote(){
            let numReg = /^[0-9]*$/;
            let numRe = new RegExp(numReg);
            if (!numRe.test(this.auditForm.score)) {
                this.$message.error("请输入数字");
                this.auditForm.score = 0;
            }else if (this.auditForm.score > 100) {
                this.$message.error("请输入小于或者等于100的分数");
                this.auditForm.score = 100;
            }
        },
    }
}
</script>

<style scoped lang="less">
/deep/.el-dialog__body {
    padding-top: 0;
}
.examine {
    h2 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 26px;
        letter-spacing: 1px;
    }
    .examineList {
        display: flex;
        align-items: center;
        img {
            width: 300px;
            height: 150px;
        }
        p:nth-of-type(1){
            margin-right: 16px;
            width: 65px;
            flex-shrink: 0;
        }
        .vHtml {
            margin: 0;
            /deep/pre {
                white-space: pre-line !important;
            }
            /deep/img {
                max-width: 100%;
            }
        }
    }
    .examineList_html {
        img {
        width: 300px;
        height: 150px;
        }
        p:nth-of-type(1){
        margin-right: 16px;
        width: 65px;
        flex-shrink: 0;
        }
        .vHtml {
        margin: 0;
        /deep/pre {
            white-space: pre-line !important;
        }
        /deep/img {
            max-width: 100%;
        }
        }
    }
    .examineListTwo {
        display: flex;
        align-items: center;
        .examineListTwo_box {
            display: flex;
            align-items: center;
            width: 50%;
        }
    }

}
.audit {
    padding-bottom: 20px;
    h3 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 26px;
        letter-spacing: 1px;
        // border-bottom: 1px solid #ddd;
        padding-bottom: 15px;
    }
    .auditContent {
        // padding: 0 30px;
    }
    .cause {
        display: flex;
        margin-top: 20px;
        .causeTitle {
            min-width: 80px;
            color: #3a8ee6;
        }
        .causeContent {
            color: #000;
        }
    }
    .auditEnter {
        text-align: center;
        padding-top: 20px;
        button {
            width: 120px;
        }
    }
}
.examineList2 {
    display: flex;
    align-items: center;
    p:nth-of-type(1){
        margin-right: 16px;
        width: 105px;
    }
}
/deep/img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/examine/leaderExamineDialog.vue